import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { networkLogos } from 'src/constants'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      video="https://assets.fubo.tv/marketing/lp/videos/compressed/CFB_ACC_16x9_10s_LP_3Mb.mp4"
      videoMobile="https://assets.fubo.tv/marketing/lp/videos/mobile/CFB_ACC_1x1_10s_LP_3Mb.mp4"
      title="Watch ACC Network with Fubo"
      subtitle="Get games, news, analysis and more"
      staticAnnotation={networkLogos.espn}
    />
  )
}
